import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";
import React, { useState } from "react";

function TextReverse() {
  const [text, setText] = useState("");
  const [copy, setCopy] = useState(false);
  const [changeNew, setChangeNew] = useState("");
  const [errors, setErrors] = useState("");

  const handleOnErase = () => {
    setText("");
    setCopy(false);
    setChangeNew("");
  };

  const handleOnChange = (event) => {
    setErrors("");
    setChangeNew("");
    setCopy(false);
    setText(event.target.value);
  };

  const handleTRClick = () => {
    if (!text || text.trim() === "") return setErrors("* Please enter text.");
    const reverseString = (str) => {
      let newString = "";
      for (let i = str.length - 1; i >= 0; i--) {
        newString += str[i];
      }
      return newString;
    };
    let newText = reverseString(text);
    setChangeNew(newText);
    setCopy(false);
  };

  return (
    <>
      <div className="main-globally-counter-box">
        {text?.length > 0 && (
          <div className="color-picker-icon">
            <i
              className="fa-solid fa-eraser"
              title="Clear"
              onClick={handleOnErase}
            ></i>
          </div>
        )}
        <div className="counter-text-area">
          <textarea
            className={errors && "error-input"}
            placeholder="Type a Text.   ( Ex. Input :- Convertor   ;   Output :- rotrevnoC)  "
            value={text}
            onChange={handleOnChange}
          />
          <span>{errors}</span>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button onClick={handleTRClick}>Reverse Text</button>
      </div>
      {changeNew?.length > 0 && (
        <div className="main-globally-counter-box">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(changeNew)} />
            {copy && changeNew && (
              <div>
                {" "}
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="counter-text-area">
            <textarea
              className="text-black"
              value={changeNew}
              disabled={true}
            />
          </div>
        </div>
      )}
    </>
  );
}
export default TextReverse;
